/* eslint-disable */
import 'jquery.cookie';
import { operators } from '@fr/constants';

import checkTourCashbackAvailable from '@/js/common/Domain/Service/checkTourCashbackAvailable';

const sortRateIncRate = parseInt($.cookie('sortRateIncRate') || 1, 10);
const userInterestsIncRate = parseInt($.cookie('userInterestsIncRate') || 0, 10);

const HotelEntity = Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        category: null,
        isPopular: false,
        highlyRated: false,
        resort: null,
        cover: null,
        photos: [],
        imagesHtml: null,
        rating: null,
        ratingDetails: null,
        reviewsQty: null,
        toursQuantity: null,
        hotelOffersQuantity: null,
        clientUrl: null,
        url: null,
        tourProducts: null,
        hotelOffers: null,
        meta: null,
        map: null,
        ordersCount: null,
        /* was computeds */
        cityTours: false,
        wellness: false,
        withKids: false,
        airConditioner: false,
        wifi: false,
        adultsOnly: false,
        forCouples: false,
        nearTheLift: false,
        warranted: false,
        nearTheCenter: false,
        lonelyMan: false,
        numOfTourists: false,
        nearTheBeach: false,
        beachLine: false,
        beachOwner: false,
        sandBeach: false,
        pebbleBeach: false,
        sortRate: null,
        sandPebbleBeach: false,
        userInterestGroups: [],
        isExclusive: false,
    },
    getCover(callback) {
        const image = this.get('cover');
        const self = this;
        const hotelId = this.get('id');
        let xhr;

        if (image === null) {
            xhr = $.ajax({
                url: `/hotel/photos?id=${hotelId}`,
            }).done((response) => {
                const { result } = response;
                if (response.success == true) {
                    self.set('cover', result.cover);
                    self.set('photos', result.photos);
                    callback ? callback(self) : null;
                }
            });

            this.set('cover', xhr);
        } else if (typeof image.readyState === 'undefined') {
            callback ? callback(self) : null;
            return image;
        }

        return null;
    },
    initIsExclusive() {
        const tourProducts = this.get('tourProducts');
        const operatorId = tourProducts.at(0).get('tour').get('operator')?.id;
        const isExclusive = operators.MY_AGENT.includes(operatorId);
        this.set('isExclusive', !!isExclusive);
    },
    initHotelOptions() {
        const tourProducts = this.get('tourProducts');
        const priceWithOilTax = tourProducts.at(0).get('tour').get('priceWithOilTax');
        let userInterestsRate = 0;

        const hasTourCashbackAvailable = checkTourCashbackAvailable(tourProducts);
        const cashback = !!(window?.appConfig?.cashbackAvailable && hasTourCashbackAvailable);

        const serverSortRate = tourProducts.at(0).get('tour').get('sortRate');
        userInterestsRate += 1;

        const resultSortRate = userInterestsRate ? (sortRateIncRate * serverSortRate + userInterestsRate * userInterestsIncRate) : '';

        this.set('minPrice', priceWithOilTax);
        this.set('sortRate', resultSortRate);
        this.set('cashback', cashback);
        this.set('priceWithOilTax', priceWithOilTax);
        this.initWarrantedOption();
        this.initIsExclusive();
    },
    initWarrantedOption() {
        const tourProducts = this.get('tourProducts');
        const warranted = tourProducts.find((tourProduct) => tourProduct.get('tour').get('hotelAvailable') === 1);
        this.set('warranted', !!warranted);
    },
});

export default HotelEntity;
